import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { BooleanDeterminant } from "../../models/boolean-determinant";
import { FileDeterminant } from "../../models/file-determinant";
import { BotDeterminant } from "../../models/bot-determinant";
import { ButtonDeterminant } from "../../models/button-determinant";
import { ClassificationDeterminant } from "../../models/classification-determinant";
import { FileUploadDeterminant } from "../../models/file-upload-determinant";
import { GridComponentDeterminant } from "../../models/grid-component-determinant";
import { CollectionPlaceDeterminant } from "../../models/collection_place-determinant";
import { DateDeterminant } from "../../models/date-determinant";
import { Determinant } from "../../models/determinant";
import { MoneyDeterminant } from "../../models/money-determinant";
import { NumericDeterminant } from "../../models/numeric-determinant";
import { RadioDeterminant } from "../../models/radio-determinant";
import { RegistrationDeterminant } from "../../models/registration-determinant";
import { SelectBoxesDeterminant } from "../../models/selectboxes-determinant";

import { SelectDeterminant } from "../../models/select-determinant";
import { SubCatalogDeterminant } from "../../models/sub-catalog-determinant";
import {TextDeterminant} from "../../models/text-determinant";
import Helpers from "../../utils/helpers";
import { GridDeterminant } from "src/app/models/grid-determinant";

@Injectable()
export class DeterminantControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getServiceDeterminantIdAndName(serviceId: string): Observable<{ [key: string]: string }> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/determinantname") as Observable<{ [key: string]: string }>;
  }

  public getServiceDeterminants(serviceId: string): Observable<Determinant[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/determinant") as Observable<Determinant[]>;
  }

  public getAllDeterminants(serviceId: string, showUsages: boolean): Observable<Determinant[]> {
    if (serviceId) {
      return this.http.get(this.baseUrl + "service/" + serviceId + "/determinant?all=true" + (showUsages ? "&usage=true" : "")) as Observable<Determinant[]>;
    } else {
      throw new Error("'serviceId' cannot be undefined!");
    }
  }

  public getDeterminant(determinantId: string) {
    return this.http.get(this.baseUrl + "determinant/" + determinantId + "?usage=true");
  }

  public createBooleanDeterminant(serviceId: string, determinant: BooleanDeterminant): Observable<BooleanDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/booleandeterminant", body) as Observable<BooleanDeterminant>;
  }

  public saveBooleanDeterminant(serviceId: string, determinant: BooleanDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/booleandeterminant", body, { responseType: "text" });
  }

  public createNumericDeterminant(serviceId: string, determinant: NumericDeterminant): Observable<NumericDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/numericdeterminant", body) as Observable<NumericDeterminant>;
  }

  public saveNumericDeterminant(serviceId: string, determinant: NumericDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/numericdeterminant", body, { responseType: "text" });
  }

  public createMoneyDeterminant(serviceId: string, determinant: MoneyDeterminant): Observable<MoneyDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/moneydeterminant", body) as Observable<MoneyDeterminant>;
  }

  public saveMoneyDeterminant(serviceId: string, determinant: MoneyDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/moneydeterminant", body, { responseType: "text" });
  }

  public createTextDeterminant(serviceId: string, determinant: TextDeterminant): Observable<TextDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/textdeterminant", body) as Observable<TextDeterminant>;
  }

    public createFileDeterminant(serviceId: string, determinant: FileDeterminant): Observable<FileDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/filedeterminant", body) as Observable<FileDeterminant>;
  }

  public saveTextDeterminant(serviceId: string, determinant: TextDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/textdeterminant", body, { responseType: "text" });
  }

  public saveFileDeterminant(serviceId: string, determinant: FileDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/filedeterminant", body, { responseType: "text" });
  }

  public createRadioDeterminant(serviceId: string, determinant: RadioDeterminant): Observable<RadioDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/radiodeterminant", body) as Observable<RadioDeterminant>;
  }

  public saveRadioDeterminant(serviceId: string, determinant: RadioDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/radiodeterminant", body, { responseType: "text" });
  }

  public createSelectDeterminant(serviceId: string, determinant: SelectDeterminant): Observable<SelectDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/selectdeterminant", body) as Observable<SelectDeterminant>;
  }

  public createSelectBoxesDeterminant(serviceId: string, determinant: SelectBoxesDeterminant): Observable<SelectBoxesDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/selectboxesdeterminant", body) as Observable<SelectBoxesDeterminant>;
  }

  public saveSelectDeterminant(serviceId: string, determinant: SelectDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/selectdeterminant", body, { responseType: "text" });
  }

  public saveSelectBoxesDeterminant(serviceId: string, determinant: SelectBoxesDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/selectboxesdeterminant", body, { responseType: "text" });
  }

  public createClassificationDeterminant(serviceId: string, determinant: ClassificationDeterminant): Observable<ClassificationDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/classificationdeterminant", body) as Observable<ClassificationDeterminant>;
  }

  public saveClassificationDeterminant(serviceId: string, determinant: ClassificationDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/classificationdeterminant", body, { responseType: "text" });
  }

  public createSubCatalogDeterminant(serviceId: string, determinant: SubCatalogDeterminant): Observable<SubCatalogDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/subcatalogdeterminant", body) as Observable<SubCatalogDeterminant>;
  }

  public saveSubCatalogDeterminant(serviceId: string, determinant: SubCatalogDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/subcatalogdeterminant", body, { responseType: "text" });
  }

  public createDateDeterminant(serviceId: string, determinant: DateDeterminant): Observable<DateDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/datedeterminant", body) as Observable<DateDeterminant>;
  }

  public saveDateDeterminant(serviceId: string, determinant: DateDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/datedeterminant", body, { responseType: "text" });
  }

  public createGridDeterminant(serviceId: string, determinant: GridDeterminant): Observable<GridDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/griddeterminant", body) as Observable<GridDeterminant>;
  }

  public saveGridDeterminant(serviceId: string, determinant: GridDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/griddeterminant", body, { responseType: "text" });
  }

  public createButtonDeterminant(serviceId: string, determinant: ButtonDeterminant): Observable<ButtonDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/buttondeterminant", body) as Observable<ButtonDeterminant>;
  }

  public saveButtonDeterminant(serviceId: string, determinant: ButtonDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/buttondeterminant", body, { responseType: "text" });
  }

  public createGridComponentDeterminant(serviceId: string, determinant: GridComponentDeterminant): Observable<GridComponentDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/gridcomponentdeterminant", body) as Observable<GridComponentDeterminant>;
  }

  public saveGridComponentDeterminant(serviceId: string, determinant: GridComponentDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/gridcomponentdeterminant", body, { responseType: "text" });
  }

  public createFileUploadDeterminant(serviceId: string, determinant: FileUploadDeterminant): Observable<FileUploadDeterminant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/fileuploaddeterminant", body) as Observable<FileUploadDeterminant>;
  }

  public saveFileUploadDeterminant(serviceId: string, determinant: FileUploadDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/fileuploaddeterminant", body, { responseType: "text" });
  }

  public createBotDeterminant(serviceId: string, determinant: BotDeterminant): Observable<Determinant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/botdeterminant", body) as Observable<Determinant> ;
  }

  public saveBotDeterminant(serviceId: string, determinant: BotDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/botdeterminant", body, { responseType: "text" });
  }

  public createRegistrationDeterminant(serviceId: string, determinant: RegistrationDeterminant): Observable<Determinant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/registrationdeterminant", body) as Observable<Determinant>;
  }

  public saveRegistrationDeterminant(serviceId: string, determinant: RegistrationDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/registrationdeterminant", body, { responseType: "text" });
  }

  public createCollectionPlaceDeterminant(serviceId: string, determinant: CollectionPlaceDeterminant): Observable<Determinant> {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/collectionplacedeterminant", body) as Observable<Determinant>;
  }

  public saveCollectionPlaceDeterminant(serviceId: string, determinant: CollectionPlaceDeterminant) {
    Helpers.trimRecursiveObj(determinant);
    const body = JSON.stringify(determinant);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/collectionplacedeterminant", body, { responseType: "text" });
  }

  public deleteDeterminant(serviceId: string, determinantId: string) {
    return this.http.delete(this.baseUrl + "service/" + serviceId + "/determinant/" + determinantId, { responseType: "text" });
  }

  // Good for updating generic stuff, type dependant stuff may not work.
  public updateDeterminant(determinant: Determinant) {
    Helpers.trimRecursiveObj(determinant);
    return this.http.put(this.baseUrl + "determinant", JSON.stringify(determinant), { responseType: "text" });
  }

  public genereateDefaultApplicantFormAndBotMapping(determinantId: string, botServiceId: string) {
    return this.http.post(this.baseUrl + "determinant/" + determinantId + "/datamapping/" + botServiceId + "/generate", null);
  }

}
